// Pure ship-to summariser for the post-approval "Production next steps" strip
// (Create-POs step's "Ships to:" line). Kept dependency-free (no React, no @/
// imports) so the qa-orders-ux-rebuild gate can IMPORT and EXECUTE it against
// fixtures — a signature-only source lint can't catch a broken legacy-fallback
// chain (the round-27 regression class), but running it can.
//
// The order's shipping-address SNAPSHOT stores canonical keys (companyName,
// stateCode …) on new records and legacy keys (company, state, line1 …) on
// older imports. shortShipTo reads canonical-first with a legacy fallback so a
// legacy-only snapshot still yields a real label (never "undefined").

/** The subset of the address snapshot shortShipTo reads. Structurally a
 *  superset of OrderDetailPage's AddressSnapshot, so it is passed directly. */
export interface ShipToInput {
  companyName?: string;
  company?: string;
  attention?: string;
  name?: string;
  street1?: string;
  line1?: string;
  city?: string;
  stateCode?: string;
  state?: string;
}

/** Compact single-line ship-to summary (e.g. "Acme Co · Austin, TX"). Returns
 *  null when the snapshot has no usable identity — the strip then renders the
 *  "set it in Addresses" prompt. Canonical keys win; legacy keys are the
 *  fallback so older imports still resolve to a real label. */
export function shortShipTo(address: ShipToInput | null): string | null {
  if (!address) return null;
  const primary =
    address.companyName ??
    address.company ??
    address.attention ??
    address.name ??
    address.street1 ??
    address.line1;
  const city = address.city;
  const state = address.stateCode ?? address.state;
  const locality = [city, state].filter(Boolean).join(", ");
  const parts = [primary, locality].filter(Boolean);
  return parts.length > 0 ? parts.join(" · ") : null;
}
